import BaseAPI from '@/apis/base/baseApi';

export default class ProxyApi extends BaseAPI {
  apiName = 'Proxy';
}
